import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const disableAngularBootstrap =
    (window as any).__DISABLE_ANGULAR_BOOTSTRAP__ === true ||
    new URLSearchParams(window.location.search).get('test_loading') === '1';

if (disableAngularBootstrap) {
    console.log('Angular bootstrap temporarily disabled for loading screen testing.');
} else {
    platformBrowserDynamic().bootstrapModule(AppModule).then(() => {
        if ('serviceWorker' in navigator && environment.production) {
            navigator.serviceWorker.getRegistrations().then(
                function(registrations) {
                    for (let registration of registrations) {
                        registration.unregister().then(result => console.log('service worker unregistered.' + result));
                    }
                }
            );
        }
    }).catch(err => console.log(err));
}
